import styled, { css } from 'styled-components';
import {PcBox as BasePcBox, MobileBox as BaseMobileBox} from './jackpot-amount.default.box';
import {styledByDevice} from '../../../../../themes/architecture/styled-by-device';
import {Color} from '../../../../../themes/definitions/casino777/casino777-colors';

const common = css`
    font-family: ${({theme}) => theme.font.family.secondary};
    font-weight: 300;
`;

const PcBox = styled(BasePcBox)`
    ${common}
    color: ${Color.papaya};
    text-shadow: 3px 3px 0 ${props => props.theme.colors.bodyText}, 0 0 0 ${props => props.theme.colors.bodyText}, 1px 1px 0 ${props => props.theme.colors.bodyText}, 2px 2px 0 ${props => props.theme.colors.bodyText}, 0 0 0 ${props => props.theme.colors.bodyText};
    -webkit-text-stroke-width: .5px;
    -webkit-text-stroke-color: ${props => props.theme.colors.bodyText};
`;

const MobileBox = styled(BaseMobileBox)`
    ${common}
    color: ${props => props.theme.colors.bodyText};
    text-shadow: none;
    letter-spacing: .3px;
    -webkit-text-stroke-width: 0;
    -webkit-text-stroke-color: ${Color.transparent};
`;

export const JackpotAmountCasino777Box = styledByDevice(PcBox, MobileBox);